<template>
  <div class="bracket">
    <template v-for="(matchup, index) in matchups">
      <div class="round" :class="{ 'round--first': index === 0 }" :key="`round-${matchup.length}`">
        <div class="spacer">&nbsp;</div>
        <template v-for="n in matchup.length / 2">
          <div class="game" :key="`game-${n}`">
            <div
              class="game__player"
              :class="{
                'game__player--winner':
                  matchup[n * 2 - 1].points < matchup[n * 2 - 2].points &&
                  (matchup[n * 2 - 2].points >= 5 || matchup[n * 2 - 1].points == -1),
                'game__player--wo':
                  matchup[n * 2 - 2].points < 0 || matchup[n * 2 - 2].points == 'wo',
              }"
            >
              <div class="game__player-content">
                <span class="game__player-target" v-if="matchup[n * 2 - 2].target">{{
                  matchup[n * 2 - 2].target
                }}</span>
                <span class="game__player-name">{{ getName(matchup[n * 2 - 2].player) }}</span>
                <span
                  v-if="index === 0 && getClub(matchup[n * 2 - 2].player)"
                  class="game__player-club"
                  >[{{ getClub(matchup[n * 2 - 2].player) }}]</span
                >
              </div>
              <b>{{
                0 > matchup[n * 2 - 2].points
                  ? '-'
                  : 0 > matchup[n * 2 - 1].points
                  ? '+'
                  : matchup[n * 2 - 2].points
              }}</b>
            </div>
            <div
              class="game__player"
              :class="{
                'game__player--winner':
                  matchup[n * 2 - 1].points > matchup[n * 2 - 2].points &&
                  (matchup[n * 2 - 1].points >= 5 || matchup[n * 2 - 2].points == -1),
                'game__player--wo':
                  matchup[n * 2 - 1].points < 0 || matchup[n * 2 - 1].points == 'wo',
              }"
            >
              <div class="game__player-content">
                <span class="game__player-target" v-if="matchup[n * 2 - 1].target">{{
                  matchup[n * 2 - 1].target
                }}</span>
                <span class="game__player-name">{{ getName(matchup[n * 2 - 1].player) }}</span>
                <span
                  v-if="index === 0 && getClub(matchup[n * 2 - 1].player)"
                  class="game__player-club"
                  >[{{ getClub(matchup[n * 2 - 1].player) }}]</span
                >
              </div>
              <b>{{
                0 > matchup[n * 2 - 1].points
                  ? '-'
                  : 0 > matchup[n * 2 - 2].points
                  ? '+'
                  : matchup[n * 2 - 1].points
              }}</b>
            </div>
          </div>
          <div class="spacer" :key="`gs-${n}`">&nbsp;</div>
        </template>
      </div>

      <div class="connection" :key="`conn-${matchup.length}`" v-if="index != matchups.length - 1">
        <div class="spacer">&nbsp;</div>
        <template v-for="n in Math.ceil(matchup.length / 4)">
          <div class="connector" :key="`c-${n}`">
            <div class="line"></div>
          </div>
          <div class="spacer" :key="`s-${n}`">&nbsp;</div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'final-bracket',
  props: {
    id: Number,
  },
  computed: {
    cache() {
      return this.$store.state.cache
    },
    matchups() {
      if (this.cache.finals.length == 0) return {}
      return this.cache.finals.find((el) => el.id == this.id)?.matchups || []
    },
  },
  methods: {
    getName(id) {
      const type = this.cache.settings.finals.find((el) => el.id == this.id).type

      if (id == null) return ''

      if (type == 0) {
        return this.cache.players.find((el) => el.id == id).name
      } else if (type == 1) {
        const item = this.cache.teams.find((el) => el.id == id)
        return `${item.club} ${item.sign}`
      } else {
        const item = this.cache.mixts.find((el) => el.id == id)
        return `${item.club} ${item.sign}`
      }
    },

    getClub(id) {
      const type = this.cache.settings.finals.find((el) => el.id == this.id).type

      if (id == null) return ''

      if (type == 0) {
        return this.cache.players.find((el) => el.id == id).club
      } else {
        return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.bracket {
  display: flex;
  user-select: none;
}

.spacer {
  flex-grow: 1;
}
.spacer:first-child,
.spacer:last-child {
  flex-grow: 0.5;
}

.round {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 300px;
}

.round--first {
  width: 400px;
}

.connection {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.game {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 0px 2px #edeff6;
  overflow: hidden;

  &__player:first-child {
    border-block-end: solid 1px $dark;
  }
  &__player {
    display: flex;
    align-items: center;

    &--winner {
      background-color: #e3ffe6;
      font-weight: 700;
    }

    &--wo {
      background-color: #fafafa;

      &::before {
        content: 'x';
        color: firebrick;
        padding-left: 8px;
        padding-top: 5px;
        box-sizing: border-box;
        display: block;
        text-align: center;
      }
    }

    span {
      padding: 6px 4px;
      text-align: left;
    }

    b {
      display: block;
      width: 24px;
      border-left: solid 1px $dark;
      background-color: #fff;
      color: $orange;
      padding: 6px 8px;
    }
  }

  &__player-target {
    font-size: 0.8em;
    font-style: italic;
    color: #888;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    &::before {
      content: '#T';
      font-size: 0.7em;
      padding-right: 3px;
    }
  }

  &__player-content {
    display: flex;
    align-items: center;
    flex-grow: 1;
    padding-left: 8px;
  }

  &__player-club {
    flex-grow: 1;
    font-size: 0.8em;
  }
}

.connector {
  position: relative;
  min-height: 144px;
  flex-grow: 1;
  width: 32px;

  .line {
    height: calc(100% - 64px);
    width: 50%;
    position: absolute;
    top: 31px;
    left: 0;
    border-top: solid 1px $dark;
    border-bottom: solid 1px $dark;
    border-right: solid 1px $dark;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &::after {
    content: '';
    width: 50%;
    height: 1px;
    background-color: $dark;
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>
